import { Box } from "@mui/material";
import styles from "./style.module.css";
import Card from "./card";
import { useState } from "react";
import LoadingButton from "../../../../../components/loading/button";
import ProjectCard from "./projectCard";
import ConfettiComponent from "../../../../../components/common/fire-works";
import { useSelector } from "react-redux";

const GridResult = () => {
  const { isLoading } = useSelector((state) => state.discover);
  const [isConfettiVisible, setIsConfettiVisible] = useState(false);
  const { data } = useSelector((state) => state.discover);

  return (
    <Box className={styles.result}>
      <ConfettiComponent isConfettiVisible={isConfettiVisible} />
      {data?.map(
        (item, index) =>
          (item.key === "user" && <Card key={index} project={item} />) ||
          (item.key === "project" && <ProjectCard key={index} project={item} />)
      )}
      {isLoading && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LoadingButton />
        </Box>
      )}
    </Box>
  );
};

export default GridResult;
